import React, { useEffect, useState } from "react";
import style from "./TroubleSkill.module.css";
import { baseurl } from "../Url";
import { useNavigate, useLocation } from "react-router-dom";
import level from "../../assests/level.svg";
import calendar from "../../assests/calendar.svg";
import question from "../../assests/question_icon.png";
import clock from "../../assests/Clock.svg";
import fav from "../../assests/favorite_icon.png";
import range from "../../assests/Rectangle.svg";
import leftArrow from "../../assests/left arrow.svg";
import Loader from "../Loder/Loader";


const TroubleSkill = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const {
    aiId = "",
    topicId = "",
    topicIndex = "",
    topicValue = "",
    moduleName = "",
    moduleIndex = "",
    searchTerm = "",
  } = location.state || {};

  const [weekstdData, setweekstdData] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const [popupText, setPopupText] = useState("");
  const [selectedSkill, setSelectedSkill] = useState(null);
  const [lastAssessmentData, setLastAssessmentData] = useState(null);
  const [loading, setLoading] = useState(true);


  const fetchDetails = async () => {
    const USERID = localStorage.getItem("USERID");
    const token = localStorage.getItem("access-token");

    if (token) {
      try {
        setLoading(true);
        const response = await fetch(`${baseurl}/practice/weak-students`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ user_id: USERID }),
        });

        if (response.ok) {
          const data = await response.json();
          if (data?.status_code === 200) {
            setweekstdData(data?.data || []);
          }
        }
      } catch (error) {
        console.error("Error fetching weak students:", error);
      }
      finally {
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    fetchDetails();
  }, []);

  const checkActiveSession = async (skill) => {
    const token = localStorage.getItem("access-token");
    const USERID = localStorage.getItem("USERID");

    try {
      const res = await fetch(`${baseurl}/practice/active-session`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          User_ID: USERID,
          main_topic_id: skill.main_topic_id,
          topic_id: skill.topic_id,
          ai_id: skill.aiId,
          mapped_skills: [
            {
              label: skill.skill_name,
              skill_id: skill.skill_id,
              skill_name: skill.skill_name,
              value: skill.skill_id,
            },
          ],
        }),
      });

      if (res.ok) {
        return await res.json();
      }
    } catch (err) {
      console.error("Session check error", err);
    }
  };
  const fectchAiId = async (topicID) => {
    const token = localStorage.getItem("access-token");
    const userId = localStorage.getItem("USERID");

    if (!token) return null;

    try {
      const response = await fetch(`${baseurl}/userlessons_ai/get`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          user_id: userId,
          topic_id: topicID,
        }),
      });

      if (response.ok) {
        const data = await response.json();
        return data?.data?.[0]?.ai_id || null;
      }
    } catch (error) {
      console.error("Error fetching AI ID:", error);
    }

    return null;
  };


  const handleSkillClick = async (skill) => {
    const fetchedId = await fectchAiId(skill.topic_id);
    const modifiedSkill = {
      ...skill,
      aiId: fetchedId || skill.ai_id,
    };
    const assessment = await checkActiveSession(modifiedSkill);

    setSelectedSkill(modifiedSkill);
    setLastAssessmentData(assessment);

    const hasSession = Boolean(assessment?.session_status);

    setPopupText(
      hasSession
        ? "Do you want to continue with your paused assessment?"
        : "Are you sure you want to start a practice session?"
    );

    setShowPopup(true);
  };

  const handlePopupYes = async () => {
      const hasActiveSession = Boolean(lastAssessmentData?.session_status);
    navigate("/practice", {
      state: {
        ai_id: selectedSkill.aiId,
        Continue: hasActiveSession,
        continue : hasActiveSession,
        main_topic_id: selectedSkill.main_topic_id,
        topic_id: selectedSkill.topic_id,
        topic_name: selectedSkill.topic_name,
        subtopic_title: selectedSkill.sub_topic_name,
        skill_id: selectedSkill.skill_id,
        skillId: selectedSkill.skill_id,
        skill_name: selectedSkill.skill_name,
        skillName: selectedSkill.skill_name,
        label: selectedSkill.skill_name,
        value: selectedSkill.skill_id,
        uniqueId: selectedSkill.skill_id,
        page_reload: true,
        mapped: [
          {
            label: selectedSkill.skill_name,
            skill_id: selectedSkill.skill_id,
            skill_name: selectedSkill.skill_name,
            value: selectedSkill.skill_id,
          },
        ],
        fromSubTopic: false,
        singleTopic: false,
        pageNum: 0,
        title: selectedSkill.skill_name,
        fromTroubleSkill: true,
      },
    });

    setShowPopup(false);
  };


  const handlePopupNo = () => {
    const hasActiveSession = Boolean(lastAssessmentData?.session_status);
    if (hasActiveSession) {
      navigate("/practice", {
        state: {
          ai_id: selectedSkill.aiId,
          aiID: selectedSkill.aiId,
          main_topic_id: selectedSkill.main_topic_id,
          mainId: selectedSkill.main_topic_id,
          topic_id: selectedSkill.topic_id,
          topicId: selectedSkill.topic_id,
          topic_name: selectedSkill.topic_name,
          subtopic_title: selectedSkill.sub_topic_name,
          skill_id: selectedSkill.skill_id,
          skillId: selectedSkill.skill_id,
          skill_name: selectedSkill.skill_name,
          skillName: selectedSkill.skill_name,
          label: selectedSkill.skill_name,
          value: selectedSkill.skill_id,
          uniqueId: selectedSkill.skill_id,
          page_reload: true,
          Continue: false,
          continue : false,
          mapped: [
            {
              label: selectedSkill.skill_name,
              skill_id: selectedSkill.skill_id,
              skill_name: selectedSkill.skill_name,
              value: selectedSkill.skill_id,
            },
          ],
          fromSubTopic: false,
          singleTopic: false,
          pageNum: 0,
          title: selectedSkill.skill_name,
          fromTroubleSkill: true,
        },
      });
      setShowPopup(false);
    } else {
      setShowPopup(false);
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB");
  };

  const formatTime = (seconds) => {
    if (!seconds) return "0:00";
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, "0")}`;
  };

  const calcProficiency = (score, total) => {
    if (!total) return 0;
    return Math.min(Math.floor((score / total) * 100 / 20), 5);
  };


  const foundModule = weekstdData.find((mod) =>
    mod.topics?.some((t) => t.topic_id === topicId)
  );
  if (loading) {
  return (
    <div className={style.Container}>
      <Loader />
    </div>
  );
}

  if (!foundModule) {
    return (
      <div className={style.Container}>
        <div className={style.topicHeader}>
          <p className={style.noData}>No trouble skills found</p>
        </div>
      </div>
    );
  }

  const foundTopic = foundModule.topics.find(
    (t) => t.topic_id === topicId
  );
  return (
    <div className={style.Container}>
      {/* <p className={style.TroubleHead}>Trouble Spot</p> */}
      <div className={style.topicHeader}>
        <img
          src={leftArrow}
          className={style.backButton}
          onClick={(e) => {
            navigate("/new/learnings", {
              state: {
                tab: "trouble-spots",
                scrollTo: "tabs"
              }
            });
          }}
        />
        <div className={style.headingP}>
          <p className={style.subtopicHP}>{foundModule.module_name} — {foundTopic.topic_name}</p>
          <p className={style.subtopicHeadingP}> {foundTopic.sub_topics[0]?.sub_topic_name || "Trouble Spot"}</p>
        </div>
      </div>

      <div className={style.subTopicsDiv}>
        {foundTopic.sub_topics.map((sub) =>
          sub.skills.map((skill, index) => {
            const sessionPercentage = skill.total_mark
              ? Math.max(0, Math.min(100, Math.floor((skill.mark_scored / skill.total_mark) * 100)))
              : 0;
            const overallRaw = Number(skill.average_performance ?? 0);
            const overallPercentage = Math.max(0, Math.min(100, Math.round(overallRaw)));
            const barsFilled = Math.min(5, Math.ceil(overallPercentage / 20)); // 0..5


            const combinedSkill = {
              ...skill,
              topic_id: foundTopic.topic_id,
              topic_name: foundTopic.topic_name,
              sub_topic_name: sub.sub_topic_name,
              main_topic_id: foundModule.module_id,
            };

            const isCompleted = skill.last_attended !== null;
            const percentage= skill?.threshold_marks ? Math.min(100,Math.round((skill?.total_mark_scored / skill?.threshold_marks) * 100)) : 0;


            return (
              <div
                key={skill.skill_id}
                className={`${style.greenCard} ${percentage > 85
                  ? style.greenComplete
                  : percentage > 40
                    ? style.yellowCard
                    : style.redCard
                  }`}
                onClick={() => handleSkillClick(combinedSkill)}
              >
                <div className={style.wholeWrapper}>
                  <div className={style.skillWrapp}>
                    <p>Skill {sub.sub_topic_id}</p>
                  </div>

                  <div className={style.mainContainer}>
                    <p className={style.understandPara}>{skill.skill_name}</p>

                    <div className={style.detailsWrapper}>
                      <div className={style.MiniWrapper}>
                        <div className={style.proWrapper}>
                          <p>Practice Level</p>
                          <img src={level} alt="" />
                        </div>
                        <div className={style.rangeContainer}>
                          {[...Array(5)].map((_, i) => (
                            <img
                              key={i}
                              src={range}
                              alt=""
                              style={{ opacity: i < barsFilled ? 1 : 0.3 }}
                            />
                          ))}
                        </div>
                      </div>

                      <div className={style.MiniWrapper}>
                        <div className={style.proWrapper}>
                          <p>Last Practiced</p>
                          <img src={calendar} alt="" />
                        </div>
                        <div className={style.DateContainer}>
                          <p>
                            {skill.last_attended
                              ? formatDate(skill.last_attended)
                              : "--"}
                          </p>
                        </div>
                      </div>

                      <div className={style.MiniWrapper}>
                        <div className={style.proWrapper}>
                          <p>Answered</p>
                          <img src={question} alt="" />
                        </div>
                        <div className={style.DateContainer}>
                          <p>{skill.sessions_count || 0}</p>
                        </div>
                      </div>

                      <div className={style.MiniWrapper}>
                        <div className={style.proWrapper}>
                          <p>Time Spent</p>
                          <img src={clock} alt="" />
                        </div>
                        <div className={style.DateContainer}>
                          <p>{formatTime(skill.total_time_spend || 0)}</p>
                        </div>
                      </div>

                      {/* Score */}
                      <div className={style.MiniWrapper}>
                        <div className={style.proWrapper}>
                          <p>Proficiency</p>
                          <img src={fav} alt="" />
                        </div>
                        <div className={style.DateContainer}>
                          <p>{sessionPercentage} %</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })
        )}
      </div>

      {showPopup && (
        <>
          <div className={style.popupOverlay}></div>
          <div className={style.Popup}>
            <div className={style.popupText}>
              <p>{popupText}</p>
            </div>

            <div className={style.PopupButton}>
              <button className={style.noButton} onClick={handlePopupNo}>
                {Boolean(lastAssessmentData?.session_status) ? "No, start again please" : "No"}
              </button>
              <button className={style.yesButton} onClick={handlePopupYes}>
                {Boolean(lastAssessmentData?.session_status) ? "Yes" : "Yes"}
              </button>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default TroubleSkill;
